import { Component, OnInit } from '@angular/core';
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';
@Component({
  selector: 'app-despliegue',
  templateUrl: './despliegue.component.html',
  styleUrls: ['./despliegue.component.scss']
})
export class DespliegueComponent implements OnInit {

  constructor(public authService: AuthService) { }

  ngOnInit() {
    this.duenio_id_n1=Number(localStorage.getItem("duenio"));
    this.api=localStorage.getItem("api");
    this.proyecto=Number(localStorage.getItem("proyecto"));
    this.responsable=Number(localStorage.getItem("responsable"));
    this.generateExcel();
  }
  api;
  total_proyecto=0;
  despliegue_=[];
  duenio_id_n1;
  proyecto;
  responsable;
  async generateExcel(){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('HK');     
      let footerRow2 = worksheet.addRow(['HOJA DE DESPLIEGUE']);
      footerRow2.getCell(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFCCFFE5' }
      };
      footerRow2.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      worksheet.mergeCells(`A${footerRow2.number}:F${footerRow2.number}`);
      var row2=worksheet.addRow(["Proyecto",localStorage.getItem("proyecto_tx")]);
      row2.eachCell((cell, number) => {
        if(number=2){
          cell.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb:'DECD98' },}               
        }
        cell.font={ color:{argb:'#ffffff'} ,size: 12};         
        cell.alignment={horizontal:"center",wrapText: true}})
      row2=worksheet.addRow(["Responsable",localStorage.getItem("responsable_tx")]);
      row2.eachCell((cell, number) => { 
        cell.font={ color:{argb:'#ffffff'} ,size: 12}; 
        if(number=2){
          cell.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb:'DECD98' },}               
        }
        cell.alignment={horizontal:"center",wrapText: true}})
      row2=worksheet.addRow(["Objetivo anual","Objetivo secundario","Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre","Total"]); 
      row2.eachCell((cell, number) => { 
        cell.font={ color:{argb:'FFFFFF'} ,size: 12}; 
        cell.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb:'000000' },}               
        cell.alignment={horizontal:"center",wrapText: true}})
        worksheet.mergeCells(`B3:C3`);   
        worksheet.mergeCells(`B2:C2`);  
         
    let postData = {
      id_hk:this.proyecto,
      usu:this.responsable,
      id_responsable:this.responsable
    }
    console.log(postData);
    
    console.log(this.api)
    await this.authService.service(this.api,postData)    
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        this.despliegue_=res;
        console.log(res);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
      });
      console.log("ok")
      var t=0;
      for(var i=0;i<this.despliegue_.length;i++){
        var l=0;
        l=(
          this.despliegue_[i].ene+
          this.despliegue_[i].feb+
          this.despliegue_[i].mar+
          this.despliegue_[i].abr+
          this.despliegue_[i].may+
          this.despliegue_[i].jun+
          this.despliegue_[i].jul+
          this.despliegue_[i].ago+
          this.despliegue_[i].sep+
          this.despliegue_[i].oct+
          this.despliegue_[i].nov+
          this.despliegue_[i].dic)/12;  
          //console.log(this.despliegue_[i]);   
        worksheet.addRow([
          this.despliegue_[i].meta,
          this.despliegue_[i].submeta,
          this.despliegue_[i].ene+"%",
          this.despliegue_[i].feb+"%",
          this.despliegue_[i].mar+"%",
          this.despliegue_[i].abr+"%",
          this.despliegue_[i].may+"%",
          this.despliegue_[i].jun+"%",
          this.despliegue_[i].jul+"%",
          this.despliegue_[i].ago+"%",
          this.despliegue_[i].sep+"%",
          this.despliegue_[i].oct+"%",
          this.despliegue_[i].nov+"%",
          this.despliegue_[i].dic+"%",l+"%"
        ]);
        t=t+l;
      }
      this.total_proyecto=t/(this.despliegue_.length+1)       
    worksheet.addRow(["","","","","","","","","","","","","","Total",this.total_proyecto+"%"]);         
    
    worksheet.getColumn(1).width = 20; 
    worksheet.getColumn(2).width = 20; 
    worksheet.getColumn(3).width = 11; 
    worksheet.getColumn(4).width = 11; 
    worksheet.getColumn(5).width = 11; 
    worksheet.getColumn(6).width = 11; 
    worksheet.getColumn(7).width = 11; 
    worksheet.getColumn(8).width = 11; 
    worksheet.getColumn(9).width = 11; 
    worksheet.getColumn(10).width = 11;
    worksheet.getColumn(11).width = 11; 
    worksheet.getColumn(12).width = 11; 
    worksheet.getColumn(13).width = 11; 
    worksheet.getColumn(14).width = 11;  
    worksheet.getColumn(1).alignment={horizontal:"center",wrapText: true,vertical:"top"};
    worksheet.getColumn(2).alignment={horizontal:"center",wrapText: true,vertical:"top"};

    worksheet.addRow([]);
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'CarData.xlsx');
    });  
    setTimeout(function(){
      window.close();
    },4000);


  }

}
